<template>
  <div>
    <!-- State: {{ store.apiState }}
    result: {{ store.apiResult }}<br /> -->
    <div v-if="store.apiState === 'loading'">
      Caricamento...
    </div>
    <div v-else-if="store.apiState === 'error'" class="error">
      <slot name="error">
        {{ store.apiResult.message }}
      </slot>
    </div>
    <div v-else>
      <slot />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAppStore } from '../stores/app'

const store = useAppStore()
const loading = computed(() => store.loading)
const error = computed(() => store.error)
</script>

<style scoped>
.error {
  color: red;
  font-weight: bold;
}
</style>
